import React from "react";
import "../assets/css/EventDetails.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";
import { useParams } from "react-router-dom";
import eventsData from "../data/eventsData";


const EventDetails = () => {
  const { id } = useParams();

  const event = eventsData.find((e) => e.id === id);

  if (!event) {
    return <h2 style={{ textAlign: "center", margin: "100px 0" }}>Event Not Found</h2>;
  }

  return (
    <>
      <BreadcrumbSection
        title="Redefining Healthcare with Precision and Passion."
        breadcrumbItems={[
          { label: "Home", to: "/" },
          { label: "Event", to: "/events" },
          { label: event.title }
        ]}
        backgroundImage={BredcrumpImage}
      />

      <div className="eventDetailsPageWrapper">
        <h1 className="eventDetailsMainTitle">Event Details</h1>

        <div className="eventDetailsCard">
          <h2 className="eventDetailsHeading">{event.title}</h2>
          <div className="eventDetailsDivider"></div>

          <div className="eventDetailsContent">
            <div className="eventDetailsImageWrapper mb-4">
              <img
                src={event.image}
                alt={event.title}
                className="eventDetailsImage"
              />
            </div>

            <div className="eventDetailsInfo">
              <p className="eventDetailsDate">
                {event.date} | {event.location}
              </p>

              <p className="eventDetailsText">{event.description}</p>
            </div>
          </div>
{/* 
          {event.document && (
            <a
              href={event.document}
              target="_blank"
              rel="noopener noreferrer"
              className="eventDetailsButton"
            >
              View Document ⬇
            </a>
          )} */}
        </div>
      </div>
    </>
  );
};


export default EventDetails;

